import { render, staticRenderFns } from "./SubventionsbeitragErstellenModal.vue?vue&type=template&id=4dd7cdd2"
import script from "./SubventionsbeitragErstellenModal.vue?vue&type=script&lang=js"
export * from "./SubventionsbeitragErstellenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports